module.exports = __webpack_public_path__ + "img/icon-zoom-out.b4589530.svg";